<template>
  <section class="product-top" v-if="page.ItemID">
    <div class="inner">
      <div class="col col-2 padded">
        <img :alt="selectedImage.alt || page.name" :src="selectedImage.image" class="product-img" v-if="selectedImage">
        <div class="thumbs">
          <a :key="image._id" @click.prevent="selected_image = image" href v-for="image in page.images">
            <img :alt="image.alt || page.name" :src="image.image" class="product-img">
          </a>
        </div>
      </div>
      <div class="col col-2 padded">
        <h1>{{page.name}}</h1>
        <h2>
          from &pound;{{page.base_price}}
        </h2>
        <a class="config-buy" href="#configure">
          <img alt="Configure and buy" src="../assets/ripple.svg"> Configure &amp; buy online
        </a>
        <span v-html="page.main_text"></span>
        <p>
          <a href="#more-info">
            Read more
            <i class="fa fa-angle-down"></i>
          </a>
        </p>
        <p class="delivery-note" v-if="page.lead_time">
          <i class="fa fa-truck"></i>
          {{page.lead_time}}
        </p>
        <p class="delivery-note" v-else-if="misc && misc.lead_time">
          <i class="fa fa-truck"></i>
          {{misc.lead_time}}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex"
export default {
  name: "ProductTop",
  data() {
    return { selected_image: null }
  },
  computed: {
    ...mapState(["page", "misc"]),
    selectedImage: function() {
      if (this.selected_image) return this.selected_image
      if (this.page.images && this.page.images.length) return this.page.images[0]
      return null
    }
  }
}
</script>
